import * as debug from "@/util/debug";

const firebaseConfig = {
  apiKey: "AIzaSyDTfI6gdpJje3JT_3gvrlhGam8TYEl6tj4",
  authDomain: "paytef-web.firebaseapp.com",
  databaseURL: "https://paytef-web.firebaseio.com",
  projectId: "paytef-web",
  storageBucket: "paytef-web.appspot.com",
  messagingSenderId: "92141823588",
  appId: "1:92141823588:web:d38721426f7bcd5f"
};

const analytics = {
  enabled: true,
  trackingID: "UA-147151304-1",
  opts: {
    scriptId: "gtagjs",
    debug: debug.isDebug() || debug.isLocalhost(),
    gtagOpt: {}
  }
};

let paymentLinkURL = "https://link.paytef.es/";
const rootWebURL = "https://my.paytef.es/";

const prodBaseURL = "https://europe-west1-paytef-web.cloudfunctions.net/api/";

let functionsBaseURL = prodBaseURL;
const tryDebugUrl = true;
if (tryDebugUrl && debug.isLocalhost()) {
  functionsBaseURL = "http://localhost:5011/paytef-web/europe-west1/apiDev/";
  //functionsBaseURL = "https://europe-west1-paytef-web.cloudfunctions.net/apiDev/";
  paymentLinkURL = "http://localhost:8092/";
} else if (debug.isDevSite()) {
  functionsBaseURL = "https://europe-west1-paytef-web.cloudfunctions.net/apiDev/";
}

export default {
  firebaseConfig,
  functionsBaseURL,
  paymentLinkURL,
  rootWebURL,
  analytics
};
